module.exports = __webpack_public_path__ + "img/comingsoon.c9a59183.png";